import { Injectable, inject } from '@angular/core';

import { GoogleTagManagerFacade } from 'ish-core/facades/gtm.facade';

/**
 * Auth analytics via DIAS GTM facade (no PII).
 * PROVISIONAL event names — add to project event catalog for production handoff.
 */
@Injectable({ providedIn: 'root' })
export class AuthAnalyticsService {
  private readonly gtm = inject(GoogleTagManagerFacade);

  trackLoginSuccess(method: 'email' | 'sso' = 'email'): void {
    this.gtm.triggeringGTMEvent('login', {
      event: 'login',
      value: { method },
    });
  }

  trackLoginFailure(reason: 'invalid_credentials' | 'lockout' | 'other' = 'invalid_credentials'): void {
    this.gtm.triggeringGTMEvent('login_failure', {
      event: 'login_failure',
      value: { reason },
    });
  }

  trackLoginLockout(): void {
    this.gtm.triggeringGTMEvent('login_lockout', {
      event: 'login_lockout',
      value: { feature: 'login' },
    });
  }

  trackAccessRequestSubmit(result: 'success' | 'failure' | 'validation_error', route?: 'admin' | 'sales'): void {
    this.gtm.triggeringGTMEvent('access_request_submit', {
      event: 'access_request_submit',
      value: {
        feature: 'request_access',
        result,
        ...(route ? { route } : {}),
      },
    });
  }

  trackPasswordResetStart(): void {
    this.gtm.triggeringGTMEvent('password_reset_start', {
      event: 'password_reset_start',
      value: { feature: 'forgot_password' },
    });
  }
}
